export default "__VITE_ASSET__17d575a0__"